module.exports = __webpack_public_path__ + "static/media/gallery-30.c1074474.jpg";